import React, { useEffect, useRef, useState } from "react";
import { SURFACE } from "./constants";

/**
 * 视口内懒加载图片
 * - 仅当元素进入视口 200px 范围时才挂载真正的 <img>
 * - 一旦加载就保持（disconnect），不会滚出后卸载再加载
 */
const LazyImage = ({
  src,
  alt = "",
  className = "",
  imgClassName = "w-full h-full object-cover",
  aspectClass = "aspect-[4/3]",
  fallback = null,
  rootMargin = "200px",
  style,
}) => {
  const containerRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!src) return;
    const el = containerRef.current;
    if (!el) return;
    // 支持的浏览器都支持 IntersectionObserver，但兜底一下
    if (typeof IntersectionObserver === "undefined") {
      setInView(true);
      return;
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { rootMargin, threshold: 0.01 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [src, rootMargin]);

  return (
    <div
      ref={containerRef}
      className={`${aspectClass} relative ${className}`}
      style={{ backgroundColor: SURFACE.soft, ...style }}
    >
      {inView && src ? (
        <img src={src} alt={alt} loading="lazy" decoding="async" className={imgClassName} />
      ) : (
        fallback
      )}
    </div>
  );
};

export default LazyImage;
